import { Quill } from '@vueup/vue-quill';

// 创建自定义 Blot
const Embed = Quill.import('blots/embed');
class HighlightBoxBlot extends Embed {
  static create(value) {
    const { value: textValue, data, node } = value;
    let newNode = node;
    if (data.highlightInput) {
      const highlightNode = document.createElement('span');
      highlightNode.setAttribute('data-value', textValue);
      highlightNode.setAttribute('data-extra', JSON.stringify(data));
      const innerNode = document.createElement('span');
      innerNode.classList.add('highlight-input');
      innerNode.contentEditable = !data?.readOnly || false;
      innerNode.innerText = textValue;
      highlightNode.appendChild(innerNode);
      newNode = highlightNode;
    }

    return newNode;
  }

  static value(node) {
    return {
      value: node?.getAttribute('data-value') ? node.getAttribute('data-value') : node.innerText,
      data: JSON.parse(node.getAttribute('data-extra')) || {}, // 解析存储的 JSON 字符串
      node,
    };
  }
}

HighlightBoxBlot.blotName = 'highlightBox';
HighlightBoxBlot.tagName = 'span';

// 获取选区和内容
function getSelectionIndexAndLength() {
  const selection = window.getSelection();

  if (!selection.rangeCount) {
    return null;
  }
  const range = selection.getRangeAt(0);
  const selectedText = selection.toString();
  const startContainer = range.startContainer;
  const startOffset = range.startOffset;

  const parentElement = startContainer.parentElement;
  const parentText = parentElement.innerText;

  const index = parentText.indexOf(selectedText, startOffset);
  const length = selectedText.length;

  return { index, length, selectedText };
}

// 点击就模板占位
let tempBtnFn = (quillEditor) => {
  const quill = quillEditor.getQuill();
  // const range = quill.getSelection(true);
  const range = getSelectionIndexAndLength();
  console.log('rangerange', range);
  let { readOnly = false } = quill.options;
  if (range && range.length > 0) {
    // const text = range.selectedText;
    const text = quill.getText(range.index, range.length);

    // 删除选中内容
    quill.deleteText(range.index, range.length);
    // 插入自定义 Blot
    quill.insertEmbed(range.index, 'highlightBox', { value: text, data: { readOnly, highlightInput: true } }, Quill.sources.USER);
    // 确保光标位置正确
    quill.setSelection(range.index + 1, Quill.sources.SILENT);
    quill.focus();
  }
};
Quill.register(HighlightBoxBlot, true);

// 获取处理好的富文本数据用于表单提交
const getContentsMapFn = (data) => {
  let result = data.ops.reduce((acc, op) => {
    if (typeof op.insert === 'string') {
      // 过滤掉只包含换行符的情况
      if (op.insert.trim() === '') {
        return acc;
      }
      return acc + op.insert;
    } else if (op.insert.highlightBox) {
      return acc + `{${op.insert.highlightBox.value}}`;
    }
    return acc;
  }, '');

  return result;
};

// 回显处理
let highlightEchoFn = (quill) => {
  const text = quill.getText();
  const deltaOps = [];
  let lastIndex = 0;
  const regex = /\{([^}]+)\}/g;
  let match;
  let { readOnly = false } = quill.options;
  while ((match = regex.exec(text)) !== null) {
    console.log('text', match, text);
    // 添加普通文本
    if (match.index > lastIndex) {
      deltaOps.push({ insert: text.slice(lastIndex, match.index) });
    }
    // 添加自定义 Blot
    deltaOps.push({ insert: { highlightBox: { value: match[1], data: { readOnly, highlightInput: true } } } });
    lastIndex = regex.lastIndex;
  }

  // 添加剩余的普通文本
  if (lastIndex < text.length) {
    deltaOps.push({ insert: text.slice(lastIndex) });
  }
  quill.setContents({ ops: deltaOps });
};

export { HighlightBoxBlot, tempBtnFn, getContentsMapFn, highlightEchoFn };
